import { useMutation } from '@apollo/client';
import { SUBMIT_TRAIT_ASSESSMENT } from '../../apollo/mutations/forcedChoice';

const useSubmitTraitAssessment = () => {
  const [submitAssessment, { data, loading, error }] = useMutation(SUBMIT_TRAIT_ASSESSMENT);
  return { submitAssessment, data, loading, error };
};

export default useSubmitTraitAssessment;